import { useRef, useState } from 'react';
import { Radio, Space, Button, Divider } from 'antd';
import XForm from 'components/XForm';
import './style.less';
const defaultFormName = 'form-' + new Date().getTime();
const Questionnaire = props => {
    const xForm = useRef();
    const { qusConfig = {}, formName = defaultFormName, onFinish, otherNode } = props;
    const { explain, qus = [], title, result } = qusConfig;
    const [totalScore, SetTotalScore] = useState(0);
    const [doneKeys, setDoneKeys] = useState([]);

    const formItems = qus.map((qu, index) => {
        const { title, options = [], tip } = qu;
        const radioNode = (
            <Radio.Group>
                <Space direction="vertical">
                    {options.map(option => {
                        const { label, score } = option;
                        return (
                            <Radio value={score} key={`score_${score}`}>
                                {`${score}分，${label}`}
                            </Radio>
                        );
                    })}
                </Space>
            </Radio.Group>
        );
        return tip
            ? {
                  formItemApis: {
                      label: <span className="requiredStar">{`${index + 1}. ${title}`}</span>,
                  },
                  id: `${formName}-${index}`,
                  item: [
                      {
                          item: tip,
                          notFormItem: true,
                      },
                      {
                          formItemApis: {
                              name: `${formName}-${index}`,
                              help: null,
                              rules: [{ required: true, message: '' }],
                          },
                          item: radioNode,
                      },
                  ],
              }
            : {
                  formItemApis: {
                      help: null,
                      name: `${formName}-${index}`,
                      label: `${index + 1}. ${title}`,
                      rules: [{ required: true, message: '' }],
                  },
                  id: `${formName}-${index}`,
                  item: radioNode,
              };
    });

    // 监听表单填写
    const onValuesChange = (changedValues, allValues) => {
        const allKeys = Object.keys(allValues);
        const doneKeys = allKeys.filter(key => {
            return allValues[key] !== undefined;
        });
        let totalScore = 0;
        doneKeys.forEach(key => {
            totalScore = totalScore + allValues[key];
        });
        SetTotalScore(totalScore);
        setDoneKeys(doneKeys);
        // 全部完成执行成功回调
        const res = result(totalScore);
        const finishObj = {
            totalScore,
            res,
        };
        if (doneKeys.length === qus.length) {
            onFinish && onFinish(finishObj);
        }
    };

    // 跳转至选题
    const testBtnClick = key => {
        document.querySelector(`#${key}`).scrollIntoView(true);
    };

    return (
        <div className="QuestionnaireBox">
            <div className="testBox">
                <div className="QuestionnaireTitle">{title}</div>
                <div className="explain">{explain}</div>
                <XForm
                    formApis={{
                        name: formName,
                        layout: 'vertical',
                        onValuesChange: onValuesChange,
                    }}
                    formItems={formItems}
                    ref={xForm}
                />
            </div>
            <div className="situationBox">
                <Space size={[8, 16]} wrap>
                    {qus.map((_, index) => {
                        const key = `${formName}-${index}`;
                        return (
                            <Button
                                key={key}
                                className={doneKeys.includes(key) ? 'doneBtn checkBtn' : 'checkBtn'}
                                onClick={() => testBtnClick(key)}>
                                {index + 1}
                            </Button>
                        );
                    })}
                </Space>
                <Divider />
                {doneKeys.length === qus.length ? (
                    <>
                        <div className="resultText">总分：{totalScore}</div>
                        {result ? (
                            <div className="resultText">评估结论：{result(totalScore)}</div>
                        ) : null}
                    </>
                ) : (
                    <>
                        <div className="resultText">
                            进度：{doneKeys.length}/{qus.length}
                        </div>
                        <div className="resultText">完成全部答题可查看结果</div>
                    </>
                )}
                {otherNode}
            </div>
        </div>
    );
};
export default Questionnaire;
